export default "__VITE_ASSET__abb238dc__"